<template>
  <transition name="fade">
    <div class="loading-box" v-show="visible">
      <img src="https://imgqn.dengyuan.vip/static/loading1.gif" alt="" />
    </div>
  </transition>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      visible: false,
      timeOut:null
    };
  },
  methods: {
    show() {
      this.visible = true;
      let that = this;
      this.timeOut = setTimeout(()=>{
        that.visible = false;
      },1000*5)
    },
    hide() {
      this.visible = false;
      clearTimeout(this.timeOut);
      this.timeOut = null;
    }
  }
};
</script>

<style type="text/scss" lang="less">
.loading-box {
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(51, 51, 51, 0.3);
  img {
    width: 10rem;
    height: 10rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue